import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import FormRanking from '../form/FormRanking';
import QuestionHeader from './QuestionHeader';
import { Typography } from '@material-ui/core';

const SubmissionRanking = ({ name, number, questionText, answers, readonly, isOptional }) => (
  <div className="box">
    <div className="col-sm-12">
      <QuestionHeader name={questionText} number={number} />
      {isOptional && <Typography variant="caption" color="textSecondary">Odpowiedź nie jest wymagana</Typography>}
      <div>
        <Field
          name={`${name}.selectedAnswersIds`}
          component={FormRanking}
          values={answers.map(answer => ({ value: answer.id, name: answer.answerText }))}
          disabled={readonly}
        />
      </div>
    </div>
  </div>
);

SubmissionRanking.propTypes = {
  name: PropTypes.string.isRequired,
  number: PropTypes.number.isRequired,
  questionText: PropTypes.string.isRequired,
  answers: PropTypes.array.isRequired,
  readonly: PropTypes.bool,
  isOptional: PropTypes.bool,
};

export default SubmissionRanking;



// WEBPACK FOOTER //
// ./src/components/consultationSurveys/SubmissionRanking.js